// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","289":"tos","296":"privacy"}[chunkId] + "." + {"176":"83e22610","289":"3cce24d8","296":"7fd5dcbc"}[chunkId] + ".js";
};